'use strict';

var focusHelper = require('../components/focus');

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    if (!$('.tracking-consent').data('caonline')) {
        return;
    }

    var urlContent = $('.tracking-consent').data('url');
    var urlAccept = $('.tracking-consent').data('accept');
    var urlReject = $('.tracking-consent').data('reject');
    var textYes = $('.tracking-consent').data('accepttext');
    var textNo = $('.tracking-consent').data('rejecttext');
    var textHeader = $('.tracking-consent').data('heading');

    var htmlString = '<!-- Modal -->'
        + '<div class="modal show modal-cookie" id="consent-tracking" aria-modal="true" role="dialog" style="display: block;">'
        + '<div class="modal-dialog modal-dialog-cookie">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header-cookie">'
        + textHeader
        + '</div>'
        + '<div class="modal-body-cookie"></div>'
        + '<div class="button-wrapper button-wrapper-cookie">'
        + '<button class="decline btn btn-primary btn-outline-primary" data-url="' + urlReject + '" data-dismiss="modal" >'
        + textNo
        + '</button>'
        + '<button class="affirm btn btn-primary" data-url="' + urlAccept + '" autofocus data-dismiss="modal">'
        + textYes
        + '</button>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $.spinner().start();
    $('body').append(htmlString);

    $.ajax({
        url: urlContent,
        type: 'get',
        dataType: 'html',
        success: function (response) {
            $('.modal-body-cookie').html(response);
            $('#consent-tracking').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $('#consent-tracking').remove();
        }
    });

    $('#consent-tracking .button-wrapper button').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        var decline = $(this).hasClass('decline');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function () {
                if (!decline) {
                    window['ga-disable-' + $('meta[name="code-disable"]').attr('content')] = false;
                }
                $('#consent-tracking').remove();
                $.spinner().stop();
            },
            error: function () {
                $('#consent-tracking').remove();
                $.spinner().stop();
            }
        });
    });
}

module.exports = function () {
    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
        window['ga-disable-' + $('meta[name="code-disable"]').attr('content')] = true;
        showConsentModal();
    }

    if ($('.tracking-consent').hasClass('api-true')) {
        $('.tracking-consent').click(function () {
            showConsentModal();
        });
    }

    $('body').on('shown.bs.modal', '#consent-tracking', function () {
        $('#consent-tracking').siblings().attr('aria-hidden', 'true');
        $('#consent-tracking .close').focus();
    });

    $('body').on('hidden.bs.modal', '#consent-tracking', function () {
        $('#consent-tracking').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#consent-tracking', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#consent-tracking',
            firstElementSelector: '.affirm',
            lastElementSelector: '.decline',
            nextToLastElementSelector: '.affirm'
        };
        focusHelper.setTabNextFocus(focusParams);
    });
};

// 2024 tracking - start
window.setTrackingConsent = function setTrackingConsent(consent) {
    var url;
    if(consent) {
        url = $('.tracking-consent').data('accept');
    } else {
        url = $('.tracking-consent').data('reject');
    }
    console.log(url);
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function () {
            console.log('success');
        },
        error: function () {
            console.log('error');
        }
    });
}
// 2024 tracking - end


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/consentTracking.js